module.exports = __webpack_public_path__ + "static/media/drp-patient-doctor-convo.cc4b6d1a.svg";